import { SimpleSignal } from "../../utils/SimpleSignal";
import { Collection } from "../../utils/Collection";
import { ISceneAddon, SceneAddonType } from "./ISceneAddon";
import { WallAddon } from "./WallAddon";
import { RoofAddon } from "./RoofAddon";
import { Material, Mesh, Group, Object3D } from "three";
import {WallSide} from "building/Building";

export class AddonManager
{
	public static DEFAULT_SCALE = 1 / 0.305;

	private static _instance:AddonManager;

	public static getInstance(gltfScene?: Group, config?: any):AddonManager
	{
		return AddonManager._instance || (AddonManager._instance = new AddonManager(gltfScene, config));
	}

	public loadedSignal:SimpleSignal;
	private _config: any;
	private _scene: Group;
	private _items:Collection<any>;

	constructor(scene: Group, config: any)
	{
		this._scene = scene;
		this._config = config;

		const items = [];

		this.parseItems(this._config.items, items);

		this._items = new Collection(items, "id");

		this._items = new Collection(items, "id");
		this.loadedSignal = new SimpleSignal();
	}

	private parseItems(items:any, result):any
	{
		for (var i = 0; i < items.length; i++)
		{
			var item = items[i];

			var prefilled = this.prefillAlias(item);
			if (prefilled)
			{
				items[i] = prefilled;
				item = prefilled;
			}

			if (item.items)
			{
				this.parseItems(item.items, result);
			}
			else
			{
				result.push(item);
			}
		}
	}

	private prefillAlias(items: any)
	{
		if (items.type === "frames")
		{
			var source = this.findSource(items.source);

			var cloned = JSON.parse(JSON.stringify(source));

			for (var i = 0; i < cloned.items.length; ++i)
			{
				cloned.items[i].id += "_frame";
				const labelWords = cloned.items[i].label.split(" ");
				const size = labelWords[1];
				cloned.items[i].label = `Framed Opening Only ${size}`;
				cloned.items[i].rollupFrame = true;

				// This was used when we thought rollup frames were just empty holes in the walls,
				// but actually they are using the trim from the same model, but without the door.
				// cloned.items[i].visible = false;
			}

			cloned.label = items.label;

			return cloned;
		}
	}

	private findSource(sourceId: string)
	{
		var source = findNode(this._config);

		function findNode(node) {
			if (node.id === sourceId)
			{
				return node;
			}

			if (node.items)
			{
				for (var i = 0; i < node.items.length; ++i)
				{
					var found = findNode(node.items[i]);
					if (found)
					{
						return found;
					}
				}
			}

			return null;
		}

		return source;
	}

	public createAddon(id: string, wall: WallSide): ISceneAddon
	{
		var itemConfig = this._items.object[id];

		//var mesh = <Mesh>[itemConfig.mesh];
		if (!itemConfig)
		{
			return null;
		}
		switch (itemConfig.type)
		{
			case SceneAddonType.WALL:
				const addon = new WallAddon(itemConfig, wall);
				if (!addon.isValid())
				{
					return null;
				}
				return <any>addon;
			case SceneAddonType.ROOF:
				return new RoofAddon(itemConfig);
		}
//
		return null;
	}

	public createMesh(meshName:string, material?:Material | Material[], createBoundingBox = false): Object3D
	{
		var objects = this._scene;
		let obj: Object3D;

		// We replace spaces with underscores, and remove slashes, because of this: https://github.com/mrdoob/three.js/issues/17832
		var sourceObj = objects.getObjectByName(meshName.replace(/ /g, "_").replace(/\//g, ""));

		if (sourceObj instanceof Mesh)
		{
			// mesh needs to be cloned as it's transform will be modified
			obj = new Mesh(sourceObj.geometry, material || sourceObj.material);
		}
		else
		{
			obj = sourceObj.clone();
			
			if (material)
			{
				if ((<Material[]>material).length)
				{
					for (let i = 0; i < (<Material[]>material).length; ++i)
					{
						(<Mesh>obj.children[i]).material = (<Material[]>material)[i];
					}
				}
				else
				{
					for (const mesh of obj.children)
					{
						(<Mesh>mesh).material = material;
					}
				}
			}
		}
		

		obj.quaternion.set(sourceObj.quaternion.x, sourceObj.quaternion.y, sourceObj.quaternion.z, sourceObj.quaternion.w);
		obj.scale.set(sourceObj.scale.x, sourceObj.scale.y, sourceObj.scale.z);

		// position will be set later
		// mesh.position   = sourceMesh.position.clone();

		// we use 1 unit as 1 foot for metrics
		// in the 3d file though a file that should be 1 is actually 0.305
		// so we need to scale it back up to 1
		obj.scale.multiplyScalar(AddonManager.DEFAULT_SCALE);

		return obj;
	}

	public getAddonTypes()
	{
		return this._config.items;
	}
}